import * as axios from './Axios'

const PREFIX = 'admin/subuser'


export const _save = data => axios.post(`${PREFIX}/save`, data);
export const _filter = data => axios.post(`${PREFIX}/filter`, data);
export const _update = (id, data) => axios.put(`${PREFIX}/${id}/update`, data);
export const _delete = id => axios.del(`${PREFIX}/${id}/delete`)

